import { Injectable } from '@angular/core';
import { CanActivate, Router } from '@angular/router';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { catchError, map, of, timeout } from 'rxjs';
import { environment } from 'src/environment/environment';

@Injectable({ providedIn: 'root' })
export class ServerDownGuard implements CanActivate {
  constructor(
    private http: HttpClient,
    private router: Router
  ) {}

  canActivate() {
    return this.http.get(`${environment.apiUrl}/health`, {
      headers: new HttpHeaders({
        'X-Skip-Auth': 'true',     // ✅ Skip auth interceptor
        'X-Skip-Loader': 'true'   // ✅ Skip loader
      }),
      responseType: 'text'
    }).pipe(

      // ✅ HARD TIMEOUT (prevents infinite freeze)
      timeout(3000),

      // ✅ If server is UP → block server-down page
      map(() => {
        this.router.navigate(['/']);
        return false; // ✅ Block server-down page
      }),

      // ✅ If server is DOWN → allow server-down page
      catchError(() => of(true))
    );
  }
}
